import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';
import { CommonButton } from '../CommonComponents';

export const BreadCrumbBackButton = ({ handleBackClick }) => {
  let breadcrumbs = Storage.getBreadcrumbsrRecord() || [];
  const navigate = useNavigate();
  const [breadCrumbsLocal, setBreadCrumbsLocal] = useState(breadcrumbs);

  useEffect(() => {
    breadcrumbs = Storage.getBreadcrumbsrRecord() || [];
    setBreadCrumbsLocal(breadcrumbs);
  }, [breadcrumbs.length]);

  const backButton = () => {
    breadcrumbs = Storage.getBreadcrumbsrRecord() || [];
    if (breadcrumbs.length > 0) {
      const lastRoute = breadcrumbs[breadcrumbs.length - 1];
      breadcrumbs.splice(breadcrumbs.length - 1, 1);
      Storage.removeBreadcrumbsrRecord();
      Storage.setBreadcrumbsrRecord(breadcrumbs);
      if (lastRoute.url) {
        navigate({ pathname: lastRoute.url, title: lastRoute.title }, {replace: true});
      } else {
        navigate('/agrocel/dashboard', {replace: true});
      }
    }
  };
  return (
    <>
      {breadCrumbsLocal.length ? (
        <CommonButton name={'Back'} btnClass={'btnTernary mt-0 mb-0 mr-0'} type="button" onClick={backButton} />
      ) : (
        ''
      )}
    </>
  );
};
